import React from 'react';
import { ArrowRight } from 'lucide-react';
import { COLORS } from '@/data';

interface MenuButtonProps {
  icon: React.ReactElement;
  title: string;
  desc: string;
  onClick: () => void;
  gradient?: boolean;
  muted?: boolean;
}

export const MenuButton: React.FC<MenuButtonProps> = ({
  icon,
  title,
  desc,
  onClick,
  gradient,
  muted
}) => (
  <button
    onClick={onClick}
    className={`w-full ${gradient ? 'bg-gradient-to-r from-pink-500/20 to-purple-500/20 border-pink-500/30' : 'bg-zinc-800 border-zinc-700'} border rounded-2xl p-6 text-left hover:border-zinc-500 group`}
  >
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-4">
        <div
          className={`w-12 h-12 rounded-xl flex items-center justify-center ${gradient ? 'bg-gradient-to-br from-pink-500 to-purple-600' : muted ? 'bg-zinc-700' : ''}`}
          style={!gradient && !muted ? { backgroundColor: COLORS.lime } : {}}
        >
          {React.cloneElement(icon, { className: `w-6 h-6 ${gradient || muted ? 'text-white' : 'text-zinc-900'}` })}
        </div>
        <div>
          <h2 className="text-xl font-semibold text-white mb-1">{title}</h2>
          <p className="text-sm text-zinc-400">{desc}</p>
        </div>
      </div>
      <ArrowRight
        className="w-5 h-5 group-hover:translate-x-1 transition-transform"
        style={{ color: gradient ? COLORS.pink : COLORS.lime }}
      />
    </div>
  </button>
);
